import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpInterceptor, HttpParams, HttpResponse } from '@angular/common/http';
import { HttpEvent, HttpRequest } from '@angular/common/http';
import { catchError, finalize, map, Observable } from 'rxjs';
import { HttpHandler } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { UtilService } from '../services/util/util.service';

@Injectable({
  providedIn: 'root'
})
export class HttpRequestInterceptor implements HttpInterceptor {
  ignoreAPIs = ['auth/config'];
  ignoreBrandAPIs = ['auth/user', 'auth/logout', 'auth/extend-session', 'super-admin/custom-loggers', 'super-admin/set-logger-level'];
  serviceCheckAPIs = ['auth/config', 'auth/user']
  jct: string = '';

  constructor(private router: Router, private authService: AuthService, private utilService: UtilService) {
    this.jct = authService.getJunctionPath();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.ignoreAPIs.some(url => req.url.includes(url))) {
      this.utilService.showLoader();
      const csrfToken = this.getCSRFToken();
      var tokenizedReq = req;

      if (['POST', 'PUT', 'DELETE'].includes(req.method) && csrfToken) {
        tokenizedReq = req.clone({
          withCredentials: true,
          headers: req.headers.set('X-XSRF-TOKEN', csrfToken),
          params: this.getUpdatedParams(req.url, req.params),
          url: req.url.replace('/api/v1', this.jct + '/api/v1')
        });
      } else {
        tokenizedReq = req.clone({
          withCredentials: true,
          params: this.getUpdatedParams(req.url, req.params),
          url: req.url.replace('/api/v1', this.jct + '/api/v1')
        });
      }

      return next.handle(tokenizedReq).pipe(map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event.status == 422 || event.status == 500 || event.status == 400) {
            this.utilService.openSnackBar(event.statusText, 'error');
          }
          if (event.status === 401) {
            this.authService.reLogin();
          }
          if (event.status === 200) {
            if (event.body.status === "success" && event.body.message) {
              this.utilService.openSnackBar(event.body.message, 'success');
            }
          }
        }
        return event;
      }), finalize(() => {
        this.utilService.hideLoader();
        if (!req.url.includes('/auth/logout')) {
          this.authService.resetIdleTime()
        }
      }))
        .pipe(catchError(async (error: HttpErrorResponse) => {
          if (error.status === 401) {
            //console.log('Access denied for URL: ' + req.url);
            this.authService.reLogin();

          } else if (error.status == 422 || error.status == 500 || error.status == 404 || error.status == 400) {
             let errorMsg = error.error.error;
            if (error.error instanceof Blob) {
              errorMsg = JSON.parse(await error.error.text()).error;
            }
            if(errorMsg)
              this.utilService.openSnackBar(errorMsg, 'error');

          } else if (error.status == 0 || error.status == 503 || error.status == 502 ||
            (error.status == 404 && this.serviceCheckAPIs.some(url => req.url.includes(url)))) {
            this.authService.setUnavailable();
            this.router.navigateByUrl('/service-unavailable');

          } else if (error.status === 403) {
            if (req.url.includes('/auth/user')) {
              this.router.navigateByUrl('/unauthorized');
            } else {
              this.utilService.openSnackBar(error.error.message, 'error');
            }
          }
          throw error;
        })
        );
    }

    return next.handle(req.clone({
      withCredentials: true,
      url: req.url.replace('/api/v1', this.jct + '/api/v1')
    })).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 0 || error.status == 503 ||
          (error.status == 404 && this.serviceCheckAPIs.some(url => req.url.includes(url)))) {
          this.router.navigateByUrl('/service-unavailable');
        }
        throw error;
      }),
      finalize(() => {
        this.utilService.hideLoader();
        if (!req.url.includes('/auth/logout')) {
          this.authService.resetIdleTime()
        }
      })
    );
  }

  getUpdatedParams(url: string, params: HttpParams) {
    let brand: string | null = sessionStorage.getItem('brand');
    if (brand) {
      let skipUpdate = false;
      this.ignoreBrandAPIs.forEach(api => {
        if (url.includes(api)) {
          skipUpdate = true;
        }
      });

      /* if (!skipUpdate) {
        params = params.set('brand', brand);
      } */
    }
    return params;
  }

  getCSRFToken(): string {
    const value = `; ${document.cookie}`;
    const parts = value.split(/; .*XSRF-TOKEN-UDEJCT=/);

    if (parts.length == 2) {
      return parts.pop()?.split(/;|\&/).shift() || '';
    }

    return '';
  }
}